import { OpticalAndLevel } from "@/types/opticalAndLevel.type";
import { responseHandlerDefault } from "@/utils/handler.util";
import axios from "./api";

const opticalAndLevelRoute = "/optical-and-level/";

/**
 * Crear un nuevo registro OpticalAndLevel
 */
export const createOpticalAndLevel = (
  opticalAndLevel: OpticalAndLevel
): Promise<OpticalAndLevel> => {
  return axios
    .post<OpticalAndLevel>(opticalAndLevelRoute, opticalAndLevel)
    .then(responseHandlerDefault);
};

/**
 * Crear varios registros OpticalAndLevel
 */
export const createManyOpticalAndLevel = (
  opticalAndLevels: OpticalAndLevel[]
): Promise<OpticalAndLevel[]> => {
  return axios
    .post<OpticalAndLevel[]>(`${opticalAndLevelRoute}many`, opticalAndLevels)
    .then(responseHandlerDefault);
};

/**
 * Actualizar un registro OpticalAndLevel
 */
export const updateOpticalAndLevel = (
  id: number,
  opticalAndLevel: OpticalAndLevel
): Promise<OpticalAndLevel> => {
  return axios
    .put<OpticalAndLevel>(`${opticalAndLevelRoute}${id}`, opticalAndLevel)
    .then(responseHandlerDefault);
};

/**
 * Obtener los registros de un SamplingPoint
 */
export const getOpticalAndLevelsBySamplingPoint = (
  samplingPointId: number
): Promise<OpticalAndLevel[]> => {
  return axios
    .get<OpticalAndLevel[]>(opticalAndLevelRoute, {
      params: {
        samplingPointId,
      },
    })
    .then(responseHandlerDefault);
};

/**
 * Obtener los registros de un parámetro
 * dentro de un SamplingPoint.
 */
export const getOpticalAndLevelsByParameter = (
  parameterId: number,
  samplingPointId: number
): Promise<OpticalAndLevel[]> => {
  return axios
    .get<OpticalAndLevel[]>(`${opticalAndLevelRoute}parameter`, {
      params: {
        parameterId,
        samplingPointId,
      },
    })
    .then(responseHandlerDefault);
};

/**
 * Eliminar un registro OpticalAndLevel
 */
export const deleteOpticalAndLevel = (id: number): Promise<void> => {
  return axios.delete(`${opticalAndLevelRoute}${id}`).then(responseHandlerDefault);
};

/**
 * Subir imagen de OpticalAndLevel
 */
export const uploadOpticalAndLevelImage = async (point: string, file: File): Promise<any> => {
  const formData = new FormData();
  const fechaLocal = new Date().toISOString();

  formData.append("file", file);
  formData.append("dateLocal", fechaLocal);

  return axios.post(`optical-and-level/image/${point}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

/**
 * Obtener imagen de OpticalAndLevel
 */
export const getImageOpticalAndLevel = (file: string): Promise<string> => {
  return axios
    .get(`/optical-and-level/image/${file}`, {
      responseType: "blob",
    })
    .then((res) => {
      return URL.createObjectURL(responseHandlerDefault(res));
    });
};
